export function buscarPersona({ identidad, nombre, telefono, mensaje }) {
    identidad.addEventListener('blur', async function () {
        const valor = identidad.value.trim();

        mensaje.textContent = '';
        nombre.readOnly = false;

        if (valor.length < 13) {
            mensaje.textContent = 'La identidad debe tener 13 dígitos';
            mensaje.className = 'mensaje-form error';
            return;
        }

        const url = `/index.php/persona/buscar?identidad=${valor}`;
        const respuesta = await fetch(url);
        const data = await respuesta.json();

        if (data.encontrado) {
            nombre.value = data.nombre;
            telefono.value = data.telefono;
            nombre.readOnly = true;

            mensaje.textContent = 'Persona encontrada. El nombre queda bloqueado para evitar cambios accidentales.';
            mensaje.className = 'mensaje-form success';
        } else {
            nombre.value = '';
            telefono.value = '';
            nombre.readOnly = false;

            mensaje.textContent = 'Persona no registrada. Puede ingresarla manualmente.';
            mensaje.className = 'mensaje-form warning';
        }
    });
}